var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wechat-auth"},[_c('img',{staticClass:"logo",attrs:{"src":require("assets/img/logo.png")}}),_vm._v(" "),_c('mu-button',{staticClass:"button",attrs:{"color":"primary"}},[_vm._v("授权完成")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64a72974","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wechat/auth.vue
// module id = null
// module chunks = 